export default __webpack_public_path__ + "static/media/Taken.c4aa9428.svg";